import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NursingStationComponent} from './nursingstation.component';
import {routing} from './nursingstation.routing';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AutoCompleteModule, MultiSelectModule} from 'primeng/primeng';
import {LayoutModule} from '../layout/layout.module';
import {SharedTranslationModule} from '../change-language/shared-translation.module';
import {MbillServiceClassRateService} from '../configuration/mbill-service-class-rate/mbill-service-class-rate.service';
import {MbillServiceService} from '../configuration/mbill-service/mbill-service.service';
import {TrnBillBillSponsorService} from '../billing/trn-bill-bill-sponsor/trn-bill-bill-sponsor.service';
import {MbillPackageService} from '../configuration/mbill-package/mbill-package.service';
import {MbillTariffService} from '../configuration/mbill-tariff/mbill-tariff.service';
import {TrnSponsorCombinationService} from '../configuration/trn-sponsor-combination/trn-sponsor-combination.service';
import {TinvPharmacySaleListService} from '../inventory/tinv-pharmacy-sale-list/tinv-pharmacy-sale-list.service';
import {TinvPurchasePharmacyBillSettlementService} from '../inventory/tinv-purchase-pharmacy-bill-settlement/tinv-purchase-pharmacy-bill-settlement.service';
import {TinvPharmacySaleItemService} from '../inventory/tinv-pharmacy-sale-item/tinv-pharmacy-sale-item.service';
import {IpdChargesService} from '../billing/ipd-charges/ipd-charges.service';
import {AdvanceService} from '../billing/advance/advance.service';
import {MacCurrencyService} from '../configuration/mac-currency/mac-currency.service';

@NgModule({
  imports: [
    CommonModule,
    routing,
    LayoutModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule, AutoCompleteModule,
    MultiSelectModule, SharedTranslationModule
  ],
  declarations: [NursingStationComponent],
  providers: [MbillServiceClassRateService, MbillServiceService, TrnBillBillSponsorService, MbillPackageService, MbillTariffService
  , TrnSponsorCombinationService, TinvPharmacySaleListService, TinvPurchasePharmacyBillSettlementService, TinvPharmacySaleItemService,
      IpdChargesService, AdvanceService, MacCurrencyService]
})
export class NursingStationModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/nursingstation/nursingstation.module.ts